/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './language.reducer';

export const LanguageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const languageEntity = useAppSelector(state => state.language.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="languageDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.language.detail.title">Language</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.language.id">Id</Translate>
            </span>
          </dt>
          <dd>{languageEntity.id}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.language.country">Country</Translate>
            </span>
          </dt>
          <dd>{languageEntity.country}</dd>
          <dt>
            <span id="countryCode">
              <Translate contentKey="tinyMedicRestApp.language.countryCode">Country Code</Translate>
            </span>
          </dt>
          <dd>{languageEntity.countryCode}</dd>
          <dt>
            <span id="language">
              <Translate contentKey="tinyMedicRestApp.language.language">Language</Translate>
            </span>
          </dt>
          <dd>{languageEntity.language}</dd>
          <dt>
            <span id="langCode">
              <Translate contentKey="tinyMedicRestApp.language.langCode">Lang Code</Translate>
            </span>
          </dt>
          <dd>{languageEntity.langCode}</dd>
          <dt>
            <span id="langDesc">
              <Translate contentKey="tinyMedicRestApp.language.langDesc">Lang Desc</Translate>
            </span>
          </dt>
          <dd>{languageEntity.langDesc}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.language.active">Active</Translate>
            </span>
          </dt>
          <dd>{languageEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.language.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{languageEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.language.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{languageEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.language.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{languageEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.language.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{languageEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/language" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/language/${languageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LanguageDetail;
